import { portalRoles } from '../enums/portalRoles';

export const isProfileOTP = profile => profile.role === portalRoles.OTP;
